<div class="style-box-tooltip text-14 text-align-left" [style.left]="positionLeft + 'px'" [style.top]="positionTop + 'px'" [class.show-tooltip]="isVisible">
	<div [innerHTML]="tooltipHtml"></div>
</div>
